Fancybox.bind('[data-fancybox]', {
    width: 1920,
    height: 1080,
    Toolbar: {
        autoEnable: false,
        display: [
            {id: 'counter', position: 'right'},
            'close'
        ]
    },
    Thumbs: {
        autoStart: false
    }
});
